import * as React from 'react'

export interface Props {
  /** Whether the switch is active or not */
  on: boolean
  /** disables switch interaction*/
  disabled?: boolean
  /** What happens when the switch is interacted with */
  onChange: (v: boolean) => void
  dataSeleniumTarget?: string
}

/**
  A toggleable Switch component
 */
const Switch: React.FunctionComponent<Props> = ({
  on,
  disabled,
  onChange,
  dataSeleniumTarget,
  ...rest
}) => {
  const update: React.ChangeEventHandler<HTMLInputElement> = (ev) => {
    onChange(ev.target.checked)
  }

  return (
    <label className="u-line-height-none">
      <span className="switch" id="switch-wrapper">
        <input
          type="checkbox"
          onChange={update}
          checked={on}
          disabled={disabled}
          data-selenium-target={dataSeleniumTarget}
          {...rest}
        />
        <span className="switch--value" aria-hidden="true" />
      </span>
    </label>
  )
}

export default Switch
